import React, { useState, useEffect } from "react";
import SearchField from "../../components/textfield/searchField";
import "../../assets/styles/components/table.scss";
import { mdiEyeOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { Table, TableColumn } from "../../components/table";
import HeaderBar from "../../components/header/headerBar";
import { useHistory } from "react-router-dom";
import { Button } from 'antd';
import axios from "axios";
import moment from "moment";
const Notification = () => {
  const history = useHistory();
  const [data, setData] = useState([]);
  const columns = [
    {
      title: "",
      align: "left",
    },
    {
      title: "Subject",
      align: "left",
    },
    {
      title: "Time",
      align: "left",
    },
    {
      title: "Date",
      align: "left",
    },
    {
      title: "Status",
      align: "center",
    },

  ];
  const appendData = () => {
    axios.get(`/notification`).then((res) => {
      setData(data.concat(res.data?.data));
    });
  };

  useEffect(() => {
    appendData();
  }, []);

  function onCheck(id: string) {
    history.push(`/opd/list/${id}`);
  }
  const switchTitle = (item: any) => {
    switch (item.type) {
      case "so-cart-marketing":
        return item.title;
        break;
      case "cashier_discount_approve":
        return item.title;
        break;
      default:
        return `${item?.type} - ${item?.data.name}`;
        break;
    }
  }
  return (
    <div>
      <HeaderBar title="Notification" />
      <div style={{ margin: "10px 80px" }}>
        <SearchField
          placeholder="Search for Subject (Date, Subject, Treatment)"
          color="#FFF"
        />
        <div style={{ marginTop: "20px" }}>
          <Table header={columns}>
            {data.map((item: any, index) => {
              const createdAt = item?.createdAt.split(" ");
              return (
                <tr key={index} style={{ cursor: "pointer" }}>
                  <TableColumn
                    width="5%"
                    align="center"
                  >
                    {index + 1}
                  </TableColumn>
                  <TableColumn
                    width="60%"
                  >

                    {switchTitle(item)}
                  </TableColumn>
                  <TableColumn
                    width="10%"
                  >
                    {moment(createdAt).format('LT')}
                  </TableColumn>
                  <TableColumn
                    width="10%"
                  >
                    {moment(createdAt).format('DD-MM-YYYY')}
                  </TableColumn>
                  <TableColumn
                    width="10%"
                  >
                    {
                      item?.type === "cashier_discount_approve" &&
                      (<Button type="primary" shape="round" style={{ background: item?.isActived ? "#C7F0D8" : "#E76464", border: 0 }} onClick={() => history.push(item?.data?.url)}>
                        {
                          item?.isActived ?
                            'Answered'
                            :
                            'Unanswered'
                        }
                      </Button>)
                    }

                    {
                      item?.type === "patient" &&
                      (<Button type="primary" shape="round" style={{ background: item?.isActived ? "#E76464" : "#C7F0D8", border: 0 }} onClick={() => onCheck(item?.data.id)}>
                        {
                          item?.isActived ?
                            'Answered'
                            :
                            'Unanswered'
                        }
                      </Button>)
                    }
                  </TableColumn>

                </tr>
              )
            }
            )}
          </Table>
        </div>
      </div>
    </div>
  );
};
export default Notification;
